export function isTransientNetworkError(error) {
    if (!error) {
        return false;
    }

    const transientCodes = new Set([
        'ERR_INSUFFICIENT_RESOURCES',
        'ERR_NETWORK',
        'ECONNABORTED',
        'ETIMEDOUT',
    ]);

    if (transientCodes.has(error.code)) {
        return true;
    }

    return !error.response && Boolean(error.request);
}

export function isUnauthorizedError(error) {
    const status = error?.response?.status;
    return status === 401 || status === 403;
}

export async function runWithConcurrencyLimit(items, limit, worker, signal) {
    if (!items.length) {
        return;
    }

    const concurrency = Math.max(1, Math.min(limit, items.length));
    let index = 0;

    const runners = Array.from({ length: concurrency }, async () => {
        while (index < items.length) {
            if (signal?.aborted) {
                return;
            }

            const currentIndex = index;
            index += 1;
            await worker(items[currentIndex], currentIndex);
        }
    });

    await Promise.all(runners);
}
